/* Theme init — extracted from head_scripts.liquid */

window.ajax_cart = true;
window.money_format = null;
window.shop_currency = null;
window.show_multiple_currencies = false;
window.loading_url = "\/\/meadowfield.nl\/cdn\/shop\/t\/2\/assets\/loading.gif?v=50837312686733260831780496721";
window.product_image_resize = false;
window.file_url = "\/\/meadowfield.nl\/cdn\/shop\/files\/?v=1548";
window.asset_url = "\/\/meadowfield.nl\/cdn\/shop\/t\/2\/assets\/soldout.png?v=175868238061993090611780496721";
window.image_swap = "true";
window.images_size = {
  is_crop: false,
  ratio_width: 1,
  ratio_height: 1.35
};
window.inventory_text = {
  in_stock: "Op voorraad",
  many_in_stock: "Voldoende op voorraad",
  out_of_stock: "Uitverkocht",
  add_to_cart: "In winkelwagen",
  sold_out: "Uitverkocht",
  unavailable: "Tijdelijk niet op voorraad",
  sale: "Aanbieding"
};
window.side_bar = {
  show_sidebar: "Filters weergeven",
  hide_sidebar: "Filters verbergen"
};
window.multi_lang = false;

(function() {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function() {
    if (typeof LazyLoad !== 'undefined') {
      new LazyLoad({});
    }

    // Scroll-reveal — replaces WOW.js. Adds .is-visible when element enters viewport.
    var revealEls = document.querySelectorAll('.wow');
    if (revealEls.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px' });
        revealEls.forEach(function(el) { io.observe(el); });
      } else {
        revealEls.forEach(function(el) { el.classList.add('is-visible'); });
      }
    }

    if (typeof jQuery !== 'undefined') {
      jQuery('iframe#kiyohIframe').attr('src', 'https://www.kiyoh.com/retrieve-widget.html?color=white&button=true&lang=nl&tenantId=98&locationId=1042844');

      var body = jQuery('body');
      var doc = jQuery(document);
      var showLeftPush = jQuery('#showLeftPush');
      var nav = jQuery('#cbp-spmenu-s1');

      showLeftPush.on('click', function(e) {
        e.stopPropagation();
        body.toggleClass('cbp-spmenu-push-toright');
        nav.toggleClass('cbp-spmenu-open');
        showLeftPush.toggleClass('active');
        showLeftPush.attr('aria-expanded', showLeftPush.hasClass('active') ? 'true' : 'false');
      });

      jQuery('.gf-menu-device-wrapper .close-menu').on('click', function() {
        showLeftPush.trigger('click');
      });

      doc.on('click', function(e) {
        if (!jQuery(e.target).closest('#cbp-spmenu-s1').length && showLeftPush.hasClass('active')) {
          showLeftPush.trigger('click');
        }
      });
    }
  });
})();
